export const MAPTIVE_TUTORIAL_YOUTUBE_ID = 'uAqGpBPws7E';
